export default __webpack_public_path__ + "static/media/Human Performance Coaching in Professional Sports.89186b68.pdf";